// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { BreakRecord } from "../../types";

const breakRecordsModule = {
  async create(data: {
    userId: string;
    taskId?: string;
    timeEntryId?: string;
  }): Promise<BreakRecord> {
    const result = await sql`
      INSERT INTO break_records (user_id, task_id, time_entry_id)
      VALUES (${data.userId}, ${data.taskId}, ${data.timeEntryId})
      RETURNING *
    `;
    return result[0] as BreakRecord;
  },

  async endBreak(breakId: string, userId: string): Promise<BreakRecord | null> {
    try {
      const result = await sql`
        UPDATE break_records
        SET end_time = NOW()
        WHERE id = ${breakId} AND user_id = ${userId} AND end_time IS NULL
        RETURNING *
      `;
      return result[0] as BreakRecord || null;
    } catch (error) {
      console.error('Error ending break:', error);
      return null;
    }
  },

  async findActiveBreak(userId: string): Promise<BreakRecord | null> {
    try {
      const result = await sql`
        SELECT * FROM break_records
        WHERE user_id = ${userId} AND end_time IS NULL
        ORDER BY start_time DESC
        LIMIT 1
      `;
      return result[0] as BreakRecord || null;
    } catch (error) {
      console.error('Error finding active break:', error);
      return null;
    }
  },

  async getTotalBreakTime(timeEntryId: string, userId: string): Promise<number> {
    try {
      const result = await sql`
        SELECT COALESCE(SUM(duration_minutes), 0) as total_minutes
        FROM break_records
        WHERE time_entry_id = ${timeEntryId} AND user_id = ${userId}
      `;
      return result[0].total_minutes || 0;
    } catch (error) {
      console.error('Error calculating break time:', error);
      return 0;
    }
  }
};

export type BreakRecordsModule = typeof breakRecordsModule;

export function registerBreakRecords(db: { breakRecords?: BreakRecordsModule }) {
  db.breakRecords = breakRecordsModule;
}

export { breakRecordsModule as breakRecords };
